import { LogoSlider } from "./LogoSlider";
import { RevealOnScroll } from "./RevealOnScroll";

type Props = {
  locale?: "de" | "en";
  number?: string;
  variant?: "default" | "tinted";
};

const COPY = {
  de: {
    eyebrow: "REFERENZEN",
    headline: "Unternehmen, mit denen wir arbeiten",
    sub: "Unsere Arbeit ist selten laut, aber messbar. Ein Auszug von Unternehmen, die wir in den vergangenen Jahren begleitet haben:",
    closing:
      "Die Zusammenarbeit reicht von operativer Umsetzung bis hin zu strategischem Sparring und Koordination externer Partner.",
  },
  en: {
    eyebrow: "REFERENCES",
    headline: "Companies we work with",
    sub: "Our work is rarely loud, but measurable. A selection of companies we have supported in recent years:",
    closing:
      "Engagements range from operational execution to strategic sparring and coordination of external partners.",
  },
};

export function LogoReferences({ locale = "de", number, variant = "tinted" }: Props) {
  const t = COPY[locale];
  const bg = variant === "tinted" ? "bg-bg-subtle" : "bg-white";

  return (
    <section className={`${bg} py-24`}>
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-6 px-6 md:grid-cols-[64px_minmax(0,1fr)] md:gap-10 md:px-12">
        {number && (
          <div aria-hidden className="font-mono text-xs tracking-wider text-ink-4 md:pt-3">
            {number}
          </div>
        )}
        <div className="min-w-0">
          <RevealOnScroll>
            <p className="eyebrow mb-4">{t.eyebrow}</p>
            <h2 className="font-display text-[34px] leading-tight text-ink md:text-[42px] [overflow-wrap:anywhere] hyphens-auto">
              {t.headline}
            </h2>
            <p className="mt-5 max-w-[720px] text-[17px] leading-relaxed text-ink-3">
              {t.sub}
            </p>
          </RevealOnScroll>

          <div className="mt-12">
            <RevealOnScroll>
              <LogoSlider locale={locale} />
            </RevealOnScroll>
          </div>

          <RevealOnScroll>
            <p className="mt-10 max-w-[720px] text-[15px] leading-relaxed text-ink-3">
              {t.closing}
            </p>
          </RevealOnScroll>
        </div>
      </div>
    </section>
  );
}
